import { GridItem } from '@bnnvara/grids';
import { Heading } from '@bnnvara/typography';
import React, { useContext } from 'react';
import { useInView } from 'react-intersection-observer';

import CardList from '../cards/CardList';
import { FollowBrandContext } from '../FollowBrand/FollowBrandContext';
import Notification from '../Notification';
import { FollowableBrandCard } from './FollowedBrands/FollowableBrandCard';
import * as S from './styled';

export function ProfileLoggedOut() {
  const { availableBrands } = useContext(FollowBrandContext);
  const [brandTitleRef, brandTitleInView] = useInView({
    threshold: 0.8,
  });

  return (
    <>
      <GridItem columnStartSm="1" columnEndSm="12">
        <S.ProfileTitleContainer>
          <Heading element="h2" variant="one">
            Titels die je kunt volgen
          </Heading>
        </S.ProfileTitleContainer>

        <S.NotificationContainer ref={brandTitleRef}>
          <Notification
            visible={brandTitleInView}
            type="bnnvaraBrandTitleNotification"
            title="Nieuw: Titels volgen"
            closeText="Oké, Ik snap het"
            horizontalPosition="center"
            direction="up"
            delay={2000}
          >
            <p>
              Volg vanaf nu jouw favoriete BNNVARA-titel! Hier op het profiel
              tonen we het overzicht van jouw titels.
            </p>
          </Notification>
        </S.NotificationContainer>
      </GridItem>
      <CardList
        viewType="Default"
        items={availableBrands}
        renderCard={FollowableBrandCard}
      />
    </>
  );
}
